import { DeleteIcon, EditIcon, SearchIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Td,
  Text,
  Tr,
  Tooltip,
  useDisclosure,
} from "@chakra-ui/react";
import { format } from "date-fns";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const NewsItem = ({ news, onDelete, canEdit, canDelete }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="lg">
        <ModalOverlay />
        <ModalContent borderRadius="1rem">
          <ModalHeader fontSize="1.05rem" fontWeight={700} borderBottom="1px solid" borderColor="gray.100" pb={3}>
            {news.title}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody py={4}>
            <Text fontSize="0.82rem" color="gray.400" mb={3}>
              {news.authorName} — {format(new Date(news.createdAt), "dd/MM/yyyy")}
            </Text>
            <Box
              dangerouslySetInnerHTML={{ __html: news.text.replace(/(?:\r\n|\r|\n)/g, "<br>") }}
              fontSize="0.95rem"
              lineHeight={1.7}
              color="gray.700"
            />
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="green" variant="outline" size="sm" onClick={onClose}>Fechar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Tr>
        <Td maxW="220px" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" title={news.title} fontSize="0.82rem">
          {news.title}
        </Td>
        <Td fontSize="0.82rem" whiteSpace="nowrap">
          {format(new Date(news.createdAt), "dd/MM/yyyy")}
        </Td>
        <Td maxW="140px" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" fontSize="0.82rem">
          {news.authorName}
        </Td>
        <Td>
          <Flex gap={2}>
            <Tooltip label="Detalhes">
              <IconButton
                colorScheme="green"
                variant="ghost"
                aria-label="Detalhes"
                size="xs"
                onClick={onOpen}
                icon={<SearchIcon />}
              />
            </Tooltip>
            {canEdit && (
              <Tooltip label="Editar notícia">
                <IconButton
                  colorScheme="orange"
                  variant="ghost"
                  aria-label="Editar"
                  size="xs"
                  onClick={() => navigate(`/createNews/${news.newsId}`)}
                  icon={<EditIcon />}
                />
              </Tooltip>
            )}
            {canDelete && (
              <Tooltip label="Excluir notícia">
                <IconButton
                  colorScheme="red"
                  variant="ghost"
                  aria-label="Excluir"
                  size="xs"
                  isLoading={isLoading}
                  onClick={() => {
                    setIsLoading(true);
                    onDelete(news.newsId);
                  }}
                  icon={<DeleteIcon />}
                />
              </Tooltip>
            )}
          </Flex>
        </Td>
      </Tr>
    </>
  );
};
export default NewsItem;
